import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=b5ac39b2&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=b5ac39b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ac39b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ac39b2')) {
      api.createRecord('b5ac39b2', component.options)
    } else {
      api.reload('b5ac39b2', component.options)
    }
    module.hot.accept("./ContactUs.vue?vue&type=template&id=b5ac39b2&scoped=true", function () {
      api.rerender('b5ac39b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/ContactUs.vue"
export default component.exports